import { NewPasswordForm } from '@/components/domain/auth/NewPasswordForm';
import { Bounded } from '@/components/ui/Bounded';
import { NavBar } from '@/components/ui/NavBar';
import { Screen } from '@/components/ui/Screen';
import { useGoBack } from '@/lib/navigation';

/**
 * Deep-link return from the reset email. The recovery link establishes a short-lived
 * recovery session (parsed from the URL on web by supabase-js, or from the deep-link
 * fragment on native in NewPasswordForm); the form then gates the password change on
 * that session so an ordinary signed-in session can't change the password here.
 *
 * NOTE: requires the redirect URL to be allow-listed in Supabase Auth settings, and
 * is best verified on a real device with the email round-trip.
 */
export default function NewPasswordScreen() {
  const goBack = useGoBack('/sign-in');

  return (
    <Screen edges={['top']}>
      <NavBar onBack={goBack} title="Set a new password" />
      <Bounded className="px-6 pt-4">
        <NewPasswordForm />
      </Bounded>
    </Screen>
  );
}
